import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTaskDetails } from "../../Hooks/Features/Task/useTaskDetails";
import { dateConvert, getFileIcon, getStatusStyle, renderField } from "../../utils/Helper";
import * as Icons from '@fortawesome/free-regular-svg-icons';
import { useMyBucket } from "../../Hooks/Features/Pocker/useMyBucket";
import { Dropdown } from "primereact/dropdown";
import UpdateTaskStatus from "../Poker/UpdateTaskStatus";
import { SkeletonTaskDetails } from "../Loader/Loader";
import CommonGrid from "../CommonCompo/CommonGrid/CommonGrid";
import { useCommon } from "../../Hooks/Common/useCommon";
import _ from "underscore";
import { useContext } from "react";
import { ToastContext } from "../../context/ToastContext";

const TaskDetailsPopup = ({ data, setTaskDetailsPopup }) => {

  const { getValuePermission } = useCommon();
  const { showSuccess } = useContext(ToastContext);
  const { handleExpand, fieldJson, expanded, setExpanded, handlePinToggle, hoveredId, setHoveredId, editingId, setEditingId, handleChange, containerRef, navigate, setFieldValues, fieldValues, selectedTab, setSelectedTab, layoutDetails, setLayoutDetails, getTaskLayoutDetails, loader, userImageError, setUserImageError, childItemColumns, childItemRowData, getUserInitials, attachmentData, GetAttachments } = useTaskDetails({ data });
  const { handleStatusChange, statusOptionsByRow, selectedStatusByRow, getProjectUser, loadStatusOptions, setPopupValue, updateReviewer, popupValue, options } = useMyBucket({ fromTaskList: true });

  return (
    <div className="h-100">
      <div className="d-flex flex-column task-details px-2 h-100">
        <div className="d-flex align-items-center justify-content-between p-2 ps-4">
          {/* parent navigation section */}
          <div className="d-flex align-items-center gap-2 text-muted">
            <div className="d-flex align-items-center gap-1">
              <img src={layoutDetails?.basicDetails?.f_image_url} alt="" width={18} height={18} />
              <a onClick={() => getTaskLayoutDetails(layoutDetails?.basicDetails?.f_issue_id)} className='fw-semibold link-secondary link-underline link-underline-opacity-0 link-underline-opacity-75-hover c-pointer'>{layoutDetails?.basicDetails?.f_issue_key}</a>
            </div> /
            <div className="d-flex align-items-center gap-1" onMouseEnter={() => setLayoutDetails((prev) => ({ ...prev, idHovered: true }))} onMouseLeave={() => setLayoutDetails((prev) => ({ ...prev, idHovered: false }))}>
              <img src={layoutDetails?.basicDetails?.image_url} alt="" width={18} height={18} />
              <a href={layoutDetails?.basicDetails?.issue_url} target="_blank" className='fw-semibold link-secondary link-underline link-underline-opacity-0 link-underline-opacity-75-hover c-pointer'>{layoutDetails?.basicDetails?.issue_key}</a>
              {layoutDetails?.idHovered && layoutDetails?.basicDetails?.issue_url && <span className="ms-2 c-pointer" onClick={() => { if (layoutDetails?.basicDetails?.issue_url) { navigator.clipboard.writeText(layoutDetails?.basicDetails?.issue_url); showSuccess("Success", "Url Copied!"); } }}><FontAwesomeIcon icon="fa-solid fa-link" /></span>}
            </div>
          </div>

          {/* top right action buttons */}
          <div className="d-flex align-items-center gap-2">
            <button className="disabled-btn">
              <FontAwesomeIcon icon="fa-solid fa-eye" /> 1
            </button>
            <button className="disabled-btn" >
              <FontAwesomeIcon icon="fa-solid fa-share-nodes" />
            </button>
            <button className="disabled-btn" >
              <FontAwesomeIcon icon="fa-solid fa-ellipsis" />
            </button>
            <button className="sk-btn sk-btn-primary" onClick={() => setTaskDetailsPopup({ show: false })}>
              <FontAwesomeIcon icon="fa-solid fa-x" />
            </button>
          </div>
        </div>
        {loader?.popup ?
          <div className="p-2" style={{ height: "calc(100% - 40px)", overflow: "hidden" }}>
            <SkeletonTaskDetails />
          </div>
          : <div className="d-flex py-2" style={{ height: "calc(100% - 40px)" }}>
            {/* Left Section */}
            <div className="flex-1 overflow-y-auto bg-white w65" style={{ height: "100%", overflowY: "auto", scrollbarWidth: 'thin' }}>
              <div className="fw-bold fs-4 ps-4"> {layoutDetails?.basicDetails?.issue_summary}</div>
              <div className="d-flex gap-2 my-3 ps-4">
                <button className="disabled-btn"><FontAwesomeIcon icon="fa-solid fa-plus" /></button>
                <button className="disabled-btn"><FontAwesomeIcon icon="fa-solid fa-ellipsis" /></button>
              </div>

              {/* Key Details Section */}
              <section className="mb-4">
                <div className={`fs-6 fw-bold c-pointer d-flex align-items-center gap-2 ${!layoutDetails?.layout?.["Description Fields"] && "ps-4"}`} onClick={() => setExpanded((prev) => ({ ...prev, "Key Details": !prev?.["Key Details"] }))} style={{ width: "fit-content" }}>
                  {layoutDetails?.layout?.["Description Fields"]?.length > 0 && <div style={{ width: "15px" }}><FontAwesomeIcon icon={`fa-solid fa-angle-${expanded?.["Key Details"] ? "down" : "right"}`} size="sm" /></div>}
                  Key details
                </div>
                {expanded?.["Key Details"] && layoutDetails?.layout?.["Description Fields"]?.map((val, index) =>
                  <div key={index} className="mb-3 ps-4" ref={containerRef}>
                    <div className="row align-items-center py-1 mx-0">
                      <div className="col-md-5 col-12 px-0">
                        <label className="w80 fw-semibold" style={{ color: "#505258" }}>{val?.custom_field_name}</label>
                      </div>
                      <div className={`${val?.col ? `col-md-${val?.col}` : "col-md-7"} col-12 position-relative px-0`}>
                        {editingId === val?.custom_field_id ? (
                          <>
                            {renderField(val, index, (e) => { handleChange(val, e) }, fieldValues, {})}
                            <div className="position-absolute end-0 d-flex gap-2" style={{ zIndex: 10, bottom: '-40px', right: "-50%", transform: 'translateY(-50%)' }} >
                              <div className="shadow-sm border py-1 px-2"><FontAwesomeIcon icon="fa-solid fa-check" className="c-pointer" /></div>
                              <div className="shadow-sm border py-1 px-2"><FontAwesomeIcon icon="fa-solid fa-x" className="c-pointer" onClick={() => setEditingId(null)} /></div>
                            </div>
                          </>
                        ) : ( //onDoubleClick={() => { setEditingId(val?.custom_field_id); }}
                          <div className={`w-100 cursor-pointer add-edit-btn ${(val?.custom_field_key === "description" && val?.fieldValue) && "fw-normal text-black"} px-0`} style={{ color: val?.custom_field_key !== "description" ? "#7f7f7f" : "" }} >
                            {val?.type === "date" ? (dateConvert(fieldValues[val?.name]) || "N/A") :
                              ((val?.custom_field_key === "description" && val?.fieldValue) ?
                                <div style={{ width: "100%" }}>
                                  <div dangerouslySetInnerHTML={{__html: val?.fieldValue}}></div>
                                </div> :
                                val?.fieldValue || "None")
                            }
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </section>

              {/* Sub task/Child items Section */}
              <section className="my-4">
                {layoutDetails?.basicDetails?.hierarchyLevel >= 1 ?
                  <div>
                    <div className={`fs-6 fw-bold c-pointer d-flex align-items-center gap-2 ${childItemRowData?.length === 0 && "ps-4"}`} onClick={() => setExpanded((prev) => ({ ...prev, "Child Items": !prev?.["Child Items"] }))} style={{ width: "fit-content" }}>
                      {childItemRowData?.length > 0 && <div style={{ width: "15px" }}><FontAwesomeIcon icon={`fa-solid fa-angle-${expanded?.["Child Items"] ? "down" : "right"}`} size="sm" /></div>}
                      Child work items
                    </div>
                    {expanded?.["Child Items"] && <div className="me-2 mt-1 ps-4">
                      {childItemRowData?.length > 0 ? <div style={{ maxHeight: "30vh", overflow: "auto" }}>
                        <CommonGrid columns={childItemColumns} data={[{ id: 'all', title: "", children: childItemRowData }]} headerHeight={40} rowHeight={30} />
                      </div> :
                        <div className="fw-semibold" style={{ color: "#7f7f7f" }}>No child work items found.</div>
                      }
                    </div>
                    }
                  </div>
                  :
                  <div className="ps-4">
                    <div className="fs-6 fw-bold">Subtasks</div>
                    <div>
                      <span className="fw-semibold px-0" style={{ color: "#7f7f7f" }}>Upcoming feature...</span>
                    </div>
                  </div>
                }
              </section>
              <div className={`fs-6 fw-bold c-pointer d-flex align-items-center gap-2 ${!layoutDetails?.layout?.["Description Fields"] && "ps-4"}`} onClick={() => setExpanded((prev) => ({ ...prev, "Attachments": !prev?.["Attachments"] }))} style={{ width: "fit-content" }}>
                {layoutDetails?.layout?.["Description Fields"]?.length > 0 && <div style={{ width: "15px" }}><FontAwesomeIcon icon={`fa-solid fa-angle-${expanded?.["Attachments"] ? "down" : "right"}`} size="sm" /></div>}
                Attachments
              </div>
              {expanded?.["Attachments"] && (
                <div className="mt-2 ps-4 d-flex gap-2" ref={containerRef} >
                  {attachmentData.length === 0 ? (
                    <div className="text-muted fs-7 italic ps-1">No attachments available</div>
                  ) : (
                    attachmentData.map((val) => {
                      return (
                        <div
                          key={val.product_attachment_id}
                          className=" d-flex align-items-center justify-content-between p-1"
                        >
                          <div
                            className="attachment-preview-box d-flex align-items-center justify-content-center bg-white border rounded text-secondary c-pointer"
                            style={{ width: "40px", height: "40px", flexShrink: 0, position: 'relative', overflow: 'hidden' }}
                            onClick={() => GetAttachments(val.product_attachment_id, val?.attachment_file_name)} title={val.attachment_file_name}>
                            <FontAwesomeIcon icon={getFileIcon(val.attachment_filetype)} size="lg" style={{ fontSize: "25px" }} />
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              )}
              {/* Linked Work Items Section */}
              <section className="my-4 ps-4">
                <div className="fs-6 fw-bold" >Linked work items</div>
                <span className="fw-semibold px-0" style={{ color: "#7f7f7f" }}>Upcoming feature...</span>
              </section>

              {/* Activity Section */}
              <section className="ps-4">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="fs-6 fw-bold">Activity</div>
                  <div className="d-flex gap-1">
                    <button className="btn btn-sm p-1 border-0 bg-transparent text-muted rounded-circle"
                      style={{ width: '24px', height: '24px' }}>
                      <FontAwesomeIcon icon="fa-solid fa-sliders" />
                    </button>
                    <button className="btn btn-sm p-1 border-0 bg-transparent text-muted rounded-circle"
                      style={{ width: '24px', height: '24px' }}>
                      <FontAwesomeIcon icon="fa-solid fa-chevron-down" />
                    </button>
                  </div>
                </div>
                <div className="mb-4 d-flex border rounded p-1" style={{ width: "fit-content" }}>
                  {['Comments', 'History', 'Work log'].map((tab, i) => (
                    <div key={tab} className={`px-2 c-pointer fw-semibold text-nowrap ${tab === selectedTab ? 'text-primary border border-primary' : 'text-muted border-0 '}`} style={{ transition: 'all 0.2s', background: tab === selectedTab && "#E9F2FE" }} onClick={() => setSelectedTab(tab)} >{tab}</div>
                  ))}
                </div>
                <div>
                  {selectedTab === "Work log" ?
                    <div>
                      {layoutDetails?.worklogs?.length > 0 ? layoutDetails?.worklogs?.map((log, i) =>
                        <div key={i} className="d-flex gap-2 fw-semibold mb-2">
                          {!userImageError?.[log?.user_code] && log?.image_url ?
                            <img className="rounded-circle" src={log?.image_url || ""} alt="" width={35} height={35} onError={() => { setUserImageError((prev) => ({ ...prev, [log?.user_code]: true })) }} />
                            :
                            <div>
                              {getUserInitials(log?.user_display_name)}
                            </div>
                          }
                          <div>
                            <div className="d-flex alig-items-center gap-4">
                              <span >{log?.user_display_name}</span>
                              <span>logged <span className="text-black">{log?.timespent}</span></span>
                            </div>
                            <div className="mt-1 text-secondary fw-normal" style={{ fontSize: "12px" }}>{dateConvert(log?.log_datetime, "month-date-year-at-time")}</div>
                            <ul className="mt-1 ps-4">
                              {log?.comment?.split("\n")?.map((item, idx) => (
                                <li key={idx} className="pe-4">{item}</li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      )
                        :
                        <div className="text-center px-5 fw-semibold mb-4">
                          <img src="./assets/stopwatch.svg" alt="" width={150} height={150} />
                          <div className="mt-3">No time was logged for this task yet. </div>
                          <div>Logging time lets you track and report on the time spent on the work.</div>
                        </div>
                      }
                    </div>
                    : <div className="fw-semibold mb-4 ps-3" style={{ color: "#7f7f7f" }}>Upcoming feature...</div>
                  }
                </div>
              </section>
            </div>

            {/* Right Sidebar */}
            <div className="border-start px-2 w35" style={{ height: "100%", overflowY: "auto", scrollbarWidth: 'thin' }} >
              {/* Status Section */}
              <div className="d-flex align-items-center gap-2 my-2" >
                <div className="w40">
                  <Dropdown className="sk-multiselect py-2 w100" panelClassName="sk-multiselect-panel" value={selectedStatusByRow[layoutDetails?.basicDetails?.issue_id] || {}} options={statusOptionsByRow[layoutDetails?.basicDetails?.issue_id] || []} style={{ width: '100%', height: '100%', backgroundColor: 'transparent', fontWeight: "500", border: 'none', ...getStatusStyle(layoutDetails?.basicDetails?.status_name) }} optionLabel="name" placeholder={layoutDetails?.basicDetails?.status_name || 'Select Status'} onClick={() => !statusOptionsByRow[layoutDetails?.basicDetails?.issue_id]?.length && loadStatusOptions(layoutDetails?.basicDetails)}
                    onChange={(e) => {
                      const newStatus = e?.value
                      if (newStatus?.name?.trim() === "Code Review") {
                        getProjectUser(layoutDetails?.basicDetails?.project_id)
                        setPopupValue({ show: true, file: [], data: layoutDetails?.basicDetails, newStatus, fileInput: ["qa-web", "qa-api", "qa-app"]?.includes(layoutDetails?.basicDetails?.issue_type_name?.toLowerCase()) })
                        return;
                      }
                      handleStatusChange(layoutDetails?.basicDetails, newStatus, true)
                    }}
                  />
                </div>
                <button className="disabled-btn"> <FontAwesomeIcon icon="fa-solid fa-bolt" /></button>
                {/* {data?.epic && <div><button className="disabled-btn fw-semibold">{data?.epic}</button></div>} */}

              </div>

              {/* Dynamic fields sections */}
              {Object.keys(fieldJson).map((category) =>
                fieldJson[category]?.field?.length > 0 &&
                <div key={category} className="border rounded mb-2">
                  <div className="d-flex align-items-center justify-content-between c-pointer bg-light p-2" onClick={() => handleExpand(category)} >
                    <div className="d-flex align-items-center gap-2">
                      <FontAwesomeIcon icon={expanded[category] ? "fa-solid fa-angle-down" : "fa-solid fa-angle-right"} />
                      <div className="fs-6 fw-semibold">{category}</div>
                    </div>
                  </div>
                  {expanded[category] && (
                    <div className="mt-2 p-2" ref={containerRef} >
                      {_.sortBy(fieldJson[category]?.field, "order_number")?.map((val, index) => (
                        <div key={`${category}-${val?.name || index}`} className="mb-2">
                          <div className="row align-items-center p-1">
                            <div className="col-md-4 col-12 d-flex add-edit-btn w40" onMouseEnter={(e) => setHoveredId(val?.custom_field_id)} onMouseLeave={(e) => setHoveredId(null)} >
                              <label className="w80 fw-semibold" style={{ color: "#505258" }}>{val?.custom_field_name}</label>
                              <div className="w20 c-pointer" onClick={(e) => { e.stopPropagation(); handlePinToggle(val, category); }} >
                                <FontAwesomeIcon icon="fa-solid fa-thumbtack" className={`mx-1 ${hoveredId === val?.custom_field_id ? " visible" : "invisible"} ${hoveredId === val?.custom_field_id && category === "Your pinned fields" ? "text-warning visible" : "text-muted"} c-pointer `} />
                              </div>
                            </div>

                            <div className={`${val?.col ? `col-md-${val?.col}` : "col-md-8"} col-12 position-relative`}>
                              {editingId === val?.custom_field_id ? (
                                <div>
                                  {renderField(val, index, (e) => { handleChange(val, e) }, fieldValues, {})}
                                  <div className="position-absolute end-0 d-flex gap-2" style={{ zIndex: 10, bottom: '-80%', right: "-50%", transform: 'translateY(-50%)' }} >
                                    <div className="shadow-sm border py-1 px-2"> <FontAwesomeIcon icon="fa-solid fa-check" className="c-pointer" /> </div>
                                    <div className="shadow-sm border py-1 px-2"> <FontAwesomeIcon icon="fa-solid fa-x" className="c-pointer" onClick={() => setEditingId(null)} /> </div>
                                  </div>
                                </div>
                              ) : (
                                // onDoubleClick={() => { setEditingId(val?.custom_field_id); }} 
                                <div className="w-100 cursor-pointer fw-semibold text-muted add-edit-btn text-truncate" >
                                  <span className={`${val?.custom_field_key === "timeoriginalestimate" ? "og-est" : ""}`}>
                                    {val?.schema_type === "select"
                                      ? (Array.isArray(val?.option)
                                        ? val?.option.find((opt) => opt.value === fieldValues[val?.name])?.label
                                        : "None") || "None"
                                      : (val?.schema_type === "date" || val?.schema_type === "datetime")
                                        ? (dateConvert(fieldValues[val?.name] || val?.fieldValue, "date-time-month") || "N/A")
                                        : fieldValues[val?.name] || val?.fieldValue || <span style={{ color: "#7f7f7f" }}>None</span>
                                    }
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
              <div className="small text-secondary fw-semibold d-flex justify-content-between px-2 align-items-start">
                <div className="d-flex flex-column gap-1">
                  {layoutDetails?.basicDetails?.created_datetime && <div>Created  {dateConvert(layoutDetails?.basicDetails?.created_datetime, "date-time-month")}</div>}
                  {layoutDetails?.basicDetails?.updated_datetime && <div>Updated {dateConvert(layoutDetails?.basicDetails?.updated_datetime, "date-time-month")}</div>}
                  {layoutDetails?.basicDetails?.resolution_date && <div>Resolved {dateConvert(layoutDetails?.basicDetails?.resolution_date, "date-time-month")}</div>}
                </div>
                {!getValuePermission("screen_tab") && <button className="btn btn-link p-0 d-flex align-items-center gap-1 text-secondary fw-semibold" onClick={() => navigate("/screens", { state: { layout: { screen_scheme_id: layoutDetails?.basicDetails?.screen_scheme_id, screen_scheme_name: layoutDetails?.basicDetails?.screen_scheme_name } } })}><FontAwesomeIcon icon="fa-solid fa-gear" /> Configure</button>}
              </div>
            </div>
          </div>}
      </div>
      {
        popupValue?.show && <UpdateTaskStatus options={options} popupValue={popupValue} setPopupValue={setPopupValue} updateReviewer={() => updateReviewer(true)} />
      }
    </div>
  );
};



export default TaskDetailsPopup;
